export type IScreenState = {
  theme: string;
};

export const state: IScreenState = {
  theme: "one"
};
